import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../../utils/translations';
import { actionIcon } from '../ui/actionIcons';

interface QuickActionsProps {
  onRaportCaz: () => void;
  onAddNote: () => void;
  onSchedule: () => void;
}

/** Four shortcuts in one row — white tiles + slate outline icons (mockup). */
const QuickActions: React.FC<QuickActionsProps> = ({
  onRaportCaz,
  onAddNote,
  onSchedule,
}) => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Programare nouă',
      icon: actionIcon.schedule,
      onClick: onSchedule,
    },
    {
      label: 'Raport caz',
      icon: actionIcon.addReport,
      onClick: onRaportCaz,
    },
    {
      label: t.meetingNotes.addNote,
      icon: actionIcon.addNote,
      onClick: onAddNote,
    },
    {
      label: t.dashboard.raportLunar,
      icon: actionIcon.monthlyReport,
      onClick: () => navigate('/monthly-report'),
    },
  ] as const;

  return (
    <section>
      <h3 className="mb-3 text-sm font-semibold text-slate-900">
        {t.dashboard.quickActions}
      </h3>
      <div className="grid grid-cols-4 gap-2">
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.label}
              type="button"
              onClick={action.onClick}
              className="flex min-w-0 flex-col items-center gap-2 rounded-xl border border-slate-200 bg-white px-1.5 py-3.5 text-center shadow-sm transition hover:border-slate-300 hover:bg-slate-50 active:scale-[0.98]"
            >
              <Icon className="h-6 w-6 text-slate-700" strokeWidth={1.5} aria-hidden />
              <span className="w-full text-[11px] font-medium leading-snug text-slate-700 sm:text-xs">
                {action.label}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default QuickActions;
